module.exports = __webpack_public_path__ + "static/media/03.a4d0b34b.mp3";